import {APP_INITIALIZER, inject, NgModule, provideAppInitializer} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FaIconLibrary} from '@fortawesome/angular-fontawesome';
import {faFolderOpen as faRegularFolderOpen, faTrashCan} from '@fortawesome/free-regular-svg-icons';
import {
    faPuzzlePiece,
    faSitemap,
    faCube,
    faCubes,
    faFilter,
    faArrowUpShortWide,
    faArrowDownWideShort,
    faSun,
    faMoon,
    faCircleHalfStroke,
    faPowerOff,
    faInfo,
    faCircleUser as faCircleUserSolid,
    faMagnifyingGlass,
    faXmark,
    faTrash,
    faShareNodes,
    faSort,
    faHeadset,
    faBars,
    faRotateRight,
    faAngleDown,
    faAngleRight,
    faCheck,
    faPlus,
    faCopy,
    faPen,
    faPencil,
    faEllipsisVertical,
    faFilterCircleXmark,
    faGear,
    faCircleCheck,
    faCircleXmark,
    faMinus,
    faRotate,
    faFileCircleCheck,
    faCircleQuestion as faCircleQuestionSolid,
    faLayerGroup,
    faBan,
    faExpand,
    faWandMagicSparkles,
    faMagnifyingGlassMinus,
    faMagnifyingGlassPlus,
    faMaximize,
    faMinimize,
    faEye,
    faEyeSlash,
    faExclamationTriangle,
    faClockRotateLeft,
    faUpRightFromSquare,
    faCirclePlay,
    faFileLines,
    faDownload,
    faAngleUp,
    faFolderTree, faArrowRotateLeft,
    faServer,
    faCircleNodes,
    faFileShield,
    faUsers,
    faCircleInfo,
    faListOl,
    faSave
} from '@fortawesome/free-solid-svg-icons';

import {
    faCircleQuestion,
    faCircleUser
} from '@fortawesome/free-regular-svg-icons';


import {AllIcons} from "./FontAwesomeIcons";

@NgModule({
    declarations: [],
    imports: [
        FontAwesomeModule,
        CommonModule
    ],
    exports: [
        FontAwesomeModule
    ],
    providers: [
        provideAppInitializer(() => {
            const library = inject(FaIconLibrary);
            library.addIcons(...AllIcons);

            //Add FA Icons
            library.addIcons(
                faPuzzlePiece, faSitemap, faCube, faCubes, faFilter,
                faArrowUpShortWide, faArrowDownWideShort, faSun, faMoon,
                faCircleHalfStroke, faPowerOff, faInfo, faMagnifyingGlass,
                faXmark, faTrash, faShareNodes, faSort, faCircleQuestion,
                faCircleQuestionSolid, faHeadset, faBars, faRotateRight, faAngleDown,
                faAngleRight, faCheck, faPlus, faCopy, faPen, faPencil, faEllipsisVertical,
                faFilterCircleXmark, faGear, faCircleCheck, faCircleXmark,
                faMinus, faRotate, faFileCircleCheck, faLayerGroup, faBan,
                faCircleUser, faCircleUserSolid, faExpand, faWandMagicSparkles,
                faMagnifyingGlassMinus, faMagnifyingGlassPlus, faMaximize, faMinimize,
                faEye, faEyeSlash, faExclamationTriangle, faClockRotateLeft,
                faUpRightFromSquare, faCirclePlay, faFileLines, faDownload,
                faAngleUp, faRegularFolderOpen, faFolderTree, faArrowRotateLeft,
                faServer, faCircleNodes, faFileShield, faUsers, faCircleInfo, faTrashCan, faListOl,
                faSave
            );
        })

    ]
})
export class FaModule {
    constructor() {
    }
}
